/** How the SEND report words and keys what it shows: counts, wire tokens, files and domain sets. */

/** `count` and the word for it, in the singular for exactly one. */
export const plural = (count: number, singular: string, pluralForm: string): string =>
  `${count} ${count === 1 ? singular : pluralForm}`;

/** A wire token as words, e.g. `controlled_terminology` → `Controlled Terminology`. */
export const humanize = (value: string): string =>
  value.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

/**
 * A stable, unique key for each file of a result, in order. Usually its domain code, but a bundle
 * can hold two files confirmed to one domain, so a repeat is numbered (`DM`, `DM-2`).
 */
export const fileKeysOf = (files: ReadonlyArray<{ domain_code: string }>): Array<string> => {
  const seen = new Map<string, number>();
  return files.map(({ domain_code: domainCode }) => {
    const occurrence = (seen.get(domainCode) ?? 0) + 1;
    seen.set(domainCode, occurrence);
    return occurrence === 1 ? domainCode : `${domainCode}-${occurrence}`;
  });
};

/** The label for a set of domains a cross-domain check spanned, e.g. `DM ↔ LB` or `DM ↔ SE ↔ TA`. */
export const domainSetLabel = (domains: ReadonlyArray<string>): string => domains.join(' ↔ ');
